import React from "react";
import { Row, Col } from "reactstrap";
import { formatDate } from "../../Utils/format-date.js";
import submitAssessmentImg from "../../../images/new-images/submitAssessmentImg.png";
import "./SubmitPage.css";
import Rendersuccessmodal from "../Self-assessment/begin-questionnaire/submit-assessment-modal/success-modal";

const SubmitPage = (props) => {
  const userName =
    localStorage.getItem("user_name") === "null"
      ? "-"
      : localStorage.getItem("user_name");

  return (
    <div className="custom-layout">
      <Rendersuccessmodal
        nestedModal={props.nestedModal}
        submitButtonText="Go To Dashboard"
        modalSuccessMessage="Hooray!"
        modalText=" You have successfully submitted your report"
        submitAssessmentReport={props.submitAssessmentReport}
        isMultiRater={props.isMultiRater}
      />
      <Row>
        <Col md="8">
          <p className="Congratulations">Congratulations, {userName}!</p>
          <p className="You-have-completed-your-self-assessment">
            You have completed your
            <span>
              {props.isMultiRater === "true" ? "LOI 360" : "Self-Assessment"}
            </span>
          </p>
          <div className="assessment-details">
            <Row>
              <Col md="2">
                <img
                  className="assessment-Icon"
                  src={
                    localStorage.getItem("baseLink") +
                    `/media/` +
                    (props.submitAssessmentDetails &&
                      props.submitAssessmentDetails
                        .instrument__instrument_image)
                  }
                />
              </Col>
              <Col md="10">
                <p className="assessment-name">
                  {props.submitAssessmentDetails &&
                    props.submitAssessmentDetails
                      .instrument__dashboard_header_text}
                </p>
                <p className="participant-name">
                  {props.submitAssessmentDetails &&
                    props.submitAssessmentDetails.participant__full_name}
                  's
                  <span style={{marginLeft:'5px'}}>
                    {props.submitAssessmentDetails &&
                      props.submitAssessmentDetails.instrument__instrument_name}
                  </span>
                </p>
                <p className="Expiry-date">
                  {props.expired ? "Expired" : "Expires"}
                  <span style={{ marginRight:'5px'}}> on</span>
                  <span>
                    {formatDate(
                      props.submitAssessmentDetails &&
                        props.submitAssessmentDetails.expiry_date
                    )}
                  </span>
                </p>
              </Col>
            </Row>
          </div>
          <p className="Submit-in-order-to-access-your-detailed-Orientation-Reports">
            Submit in order to access your detailed Orientation Reports.
          </p>
          <button className="submit-button" onClick={props.handleReportSubmit}>
            SUBMIT
          </button>
        </Col>
        <Col md="4">
          <div className="flex-wrapper">
            <img className="image" src={submitAssessmentImg} />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default SubmitPage;



// WEBPACK FOOTER //
// ./src/new/Components/SubmitAssessment/SubmitPage.jsx